export default __webpack_public_path__ + "static/media/institute-6-min.b71dff19.webp";